import { type FC } from 'react';
import { Island, Stub, type StubProps, VStack } from '@direct-frontend/components';
import styles from './SettingsIslandWithTitleStub.module.css';

interface SettingsIslandWithTitleStubProps {
    height?: StubProps['height'];
    width?: StubProps['width'];
}

export const SettingsIslandWithTitleStub: FC<SettingsIslandWithTitleStubProps> = ({
    width = '100%',
    height = '100%',
}) => (
    <Island paddingCorrection="top-bottom" className={styles.block}>
        <div className={styles.header}>
            <VStack>
                <Stub height={32} width="100%" />
            </VStack>
        </div>

        <Stub height={height} width={width} className={styles.block} />
    </Island>
);
